import React from "react";
import { SEOHead } from "../components/SEOHead";
import { useHomeSEO } from "../hooks/useSEOData";
import { Carousel } from "../components/Carousel";
import { MediaOutletsCarousel } from "../components/MediaOutletsCarousel";
import { FeaturedPosts } from "../components/FeaturedPosts";
import { FeaturedPostHero } from "../components/FeaturedPostHero";
import { SocialMediaSection } from "../components/SocialMediaSection";

export const HomePage = () => {
  // Obtener datos SEO para homepage
  const seoData = useHomeSEO();

  return (
    <>
      {/* SEO Head */}
      <SEOHead
        title="" // Vacío para que solo muestre "Red Arauca"
        description={seoData?.description}
        keywords={seoData?.keywords}
        image={seoData?.image}
        url={seoData?.url}
        type={seoData?.type}
      />

      <div>
        {/* Carrusel principal */}
        <Carousel />

        {/* Carrusel de medios de comunicación */}
        <MediaOutletsCarousel limit={50} itemsPerView={8} />

        <div className="container py-12">
          {/* Sección de 3 noticias destacadas */}
          <FeaturedPosts limit={3} />
          {/* Post destacado especial (hero) */}
          <FeaturedPostHero />
          {/* Sección de redes sociales */}
          <SocialMediaSection />
        </div>
      </div>
    </>
  );
};
